import Parent from '../views/Parent.vue';
import ReportCpm from '../views/report-cpm/ReportCpm.vue';
// eslint-disable-next-line import/no-cycle
import { setBreadcrumb } from './index';

const reportCpmRoute = {
  path: '/report-cpm',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - CPM Transaction',
        appBarTitle: 'CPM Transaction',
        breadcrumbs: () => [
          setBreadcrumb('CPM Transaction', '/report-cpm', true),
          setBreadcrumb('List CPM Transaction', '/report-cpm'),
        ],
      },
      component: ReportCpm,
      name: 'ReportCpm',
    },
  ],

  meta: {
    title: 'BNI QRIS - CPM Transaction',
    appBarTitle: 'CPM Transaction',
  },
  component: Parent,
};

export default reportCpmRoute;
